var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100%","height":"400px","border":"1px solid red"},attrs:{"id":"map1"}}),_c('div',[_vm._v("sdszzzxcccc11111111")])])
}]

export { render, staticRenderFns }